<ng-container *ngIf="{
  systemSource: systemSource$ | async,
} as resolver">
  <settings-firebase-block
    *ngIf="resolver.systemSource === 'firebase'"
    [refresh$]="refresh$"
    [system]="system"
    [labels]="labels">
  </settings-firebase-block>
  <settings-aws-block
    *ngIf="resolver.systemSource === 'aws'"
    [refresh$]="refresh$"
    [system]="system"
    [labels]="labels">
  </settings-aws-block>
</ng-container>
